import axios from 'axios';
import settings from '@/settings';
import store from '@/store';

/**
 * `POST /recordings/access`, the CloudFront credential minter.
 *
 * Lives on the CDN, not in the API host, in order to hand the player a signed cookie credential.
 * `withCredentials` is load-bearing twice, the browser will not store the `Set-Cookie`
 * from a cross-origin response without it, nor send the cookies back on the segments.
 */
const instance = axios.create({
  baseURL: settings.api.plataformas.cdn,
  withCredentials: true,
  headers: settings.api.plataformas.headers,
});

instance.interceptors.request.use(async (xhr) => {
  const authUser = store.state.AuthFirebase.auth.currentUser;

  if (authUser) {
    // eslint-disable-next-line no-param-reassign
    xhr.headers.Authorization = `Bearer ${await authUser.getIdToken()}`;
  }

  return xhr;
});

/**
 * Reject and let the caller degrade.
 */
instance.interceptors.response.use(
  (xhr) => xhr,
  (error) => Promise.reject(error),
);

export default instance;
